import useAppView from "./useAppView";

const WebOnly = ({children}) => {
    const { isDesktopWeb } = useAppView();

    if (!isDesktopWeb) return null;

    return <>
        {children}
    </>;
}

export default WebOnly;
